import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any): any{
    const url = this.sanitizer.sanitize(SecurityContext.URL, value.toString());
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
